import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import Config from '@skin_config';
import Spinner from '@common/components/spinner';
import Timer from '@common/components/timer';
import { useTranslation } from '@common/hooks/translation';
import { PopupContext } from '@app/dev/contexts/popup';

const SuperbetOfferReview = ({ isCounterOffer }) => {
  const t = useTranslation();
  const [{ closePopup }] = useContext(PopupContext);

  return (
    <div className="popup-content popup-small superbet-popup">
      <h3 className="popup-title">{isCounterOffer ? t('Counter Offer') : t('Superbet')}</h3>
      <div className="popup-main-content">
        <p className="text-center">{t('Offer is under review, please wait')}</p>
        <div className="superbet-spinner-wrapper">
          <Spinner />
        </div>
        <Timer onFinish={closePopup} duration={Config.main.superBetCountdownTime} />
      </div>
    </div>
  );
};

SuperbetOfferReview.propTypes = {
  isCounterOffer: PropTypes.bool,
};

export default SuperbetOfferReview;
